
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles'; // Global CSS has to be imported
import '@mdi/font/css/materialdesignicons.css';

export default createVuetify({
    components,
    directives,
    theme: {
      defaultTheme: 'CustomWSMPTheme',
      themes: {
        CustomWSMPTheme: {
          dark: false,
          colors: {
            primary: '#0D62D3',
            secondary:'#e2ecf9',
            green: '#006800',
            white: '#ffffff',
            //warning:'#f0ad4e',
            //danger:'#d9534f',
          }
        }
      }
    }
})